import { $t } from '@/locales';

/**
 * Transform record to option
 *
 * @example
 *   ```ts
 *   const record = {
 *     key1: 'label1',
 *     key2: 'label2'
 *   };
 *   const options = transformRecordToOption(record);
 *   // [
 *   //   { value: 'key1', label: 'label1' },
 *   //   { value: 'key2', label: 'label2' }
 *   // ]
 *   ```;
 *
 * @param record
 */
export function transformRecordToOption<T extends Record<string, string>>(record: T) {
  return Object.entries(record).map(([value, label]) => ({
    value,
    label
  })) as CommonType.Option<keyof T>[];
}

/**
 * Translate options
 *
 * @param options
 */
export function translateOptions(options: CommonType.Option<string>[]) {
  return options.map(option => ({
    ...option,
    label: $t(option.label)
  }));
}

export function getCookie(name: string): string {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || '';
  return '';
}
export const parse = (input: string) => {
  const nums = input.replace(/,/g, '').trim();
  if (/^\d+(\.(\d+)?)?$/.test(nums)) return Number(nums);
  return nums === '' ? null : Number.NaN;
};
// export const format = (value: number | null) => {
//   if (value === null) return '';
//   return value.toLocaleString('en-US');
// };
// export const format = (value: number | null, digits: number = 3) => {
//   if (value === null) return '';
//   return Number.parseFloat(value.toFixed(digits)).toLocaleString('en-US', { maximumFractionDigits: digits });
// };

export const format = (value: number | null, digits: number = 3): string => {
  // Handle null, undefined, and invalid inputs
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '';
  }

  try {
    // Ensure value is treated as a number
    const numericValue = Number(value);

    // Check if it's a valid number after conversion
    if (!Number.isFinite(numericValue)) {
      return '';
    }

    // Format the number with specified digits and locale
    return numericValue.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits,
      useGrouping: true
    });
  } catch (error) {
    console.log(`Error formatting value: ${value}`, error);
    return '';
  }
};
